<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="d-flex justify-content-end">
          <McButton
            variant="secondary"
            class="me-2"
            icon="icon-fill_close"
            :text="$t('global.cancel')"
            @click="handleBack"
          />

          <McButton
            variant="primary"
            type="submit"
            icon="icon-outline_save"
            :text="$t('global.save')"
            @click="handleSubmit"
          />
        </div>
      </div>
    </div>

    <div class="clearfix mb-4">
      <h4 class="card-title float-start">
        {{ $t('maintenance.frontPage.title.infoCompService') }}
      </h4>
    </div>

    <b-skeleton-wrapper :loading="$route.params.serviceId && !serviceForm.categoryService">
      <template #loading>
        <b-card>
          <b-row class="my-3">
            <b-col>
              <b-skeleton width="100%" height="100px" />
            </b-col>
            <b-col>
              <b-row>
                <b-col md="3">
                  <b-skeleton width="70%" height="100px" />
                </b-col>
                <b-col md="3">
                  <b-skeleton width="70%" height="100px" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="my-5">
            <b-col md="6">
              <b-skeleton width="70%" height="100px" />
            </b-col>
          </b-row>
          <b-row class="my-5">
            <b-col md="6">
              <b-skeleton width="70%" height="100px" />
            </b-col>
          </b-row>
          <b-row class="my-5">
            <b-col>
              <b-skeleton width="100%" height="50px" />
            </b-col>
            <b-col>
              <b-skeleton width="100%" height="50px" />
            </b-col>
          </b-row>
          <b-row class="my-5">
            <b-col>
              <b-skeleton width="100%" height="50px" />
            </b-col>
            <b-col>
              <b-skeleton width="100%" height="50px" />
            </b-col>
          </b-row>
        </b-card>
      </template>
      <b-card>
        <FormulateForm ref="serviceForm" v-model="serviceForm">
          <b-row class="mb-3 pb-3">
            <b-col md="6">
              <FormulateInput
                v-model="serviceForm.compServiceSelect"
                type="value-help"
                :placeholder="`${$t('global.form.select')} ${$t('maintenance.form.compService')}`"
                :listGetter="queryCompService.get"
                :label="$t('maintenance.form.compService')"
                :tableFields="fieldCompService"
                :trackBy="'serviceId'"
                :displayedBy="'name'"
                :initialObject="servicesDatas"
                validation="required"
                error-behavior="submit"
                validation-behavior="submit"
                :visibleValidationErrors="true"
                :help="'required'"
                :disabled="isEdit"
              >
                <template #label>
                  <div class="d-flex justify-content-between align-items-center">
                    <label>{{ $t('maintenance.form.compService') }} </label>
                  </div>
                </template>
              </FormulateInput>
            </b-col>
            <b-col md="6">
              <b-row>
                <b-col sm="4" xl="3">
                  <label>{{ $t('global.activity') }}</label>
                  <p class="mt-2">
                    {{ serviceForm.serviceAction }}
                  </p>
                </b-col>

                <b-col sm="6" xl="9">
                  <label>{{ $t('maintenance.form.catService') }}</label>
                  <p class="mt-2">
                    {{ serviceForm.categoryService }}
                  </p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row md="12" class="py-3 my-3 metode-penjadwalan-options">
            <label>{{ $t('maintenance.methodScheduler') }}</label>
            <div class="d-flex flex-row">
              <b-col
                v-for="option in methodSchedulerOptions"
                :key="option.key"
                md="3"
                class="my-1 ps-0 ms-0"
              >
                <McRadioButton
                  :id="option.key"
                  :key="option.key"
                  v-model="methodScheduler"
                  v-b-tooltip.hover
                  name="method"
                  :initialValue="option.key"
                  :label="`${option.label}`"
                  :description="option.description"
                  :title="option.tooltip"
                  @click="setMethod(option.key)"
                />
              </b-col>
            </div>
          </b-row>
          <b-row md="6" class="my-1 service-param-options">
            <label>{{ $t('maintenance.form.serviceParameter') }}</label>
            <div class="d-flex flex-row">
              <b-col
                v-for="option in parameterServiceOptions"
                :key="option.key"
                md="3"
                class="my-1"
              >
                <McRadioButton
                  :id="option.key"
                  :key="option.key"
                  v-model="serviceParameter"
                  name="type"
                  :initialValue="option.key"
                  :label="`${option.label}`"
                  class="me-3"
                  @click="setParameter(option.key)"
                />
              </b-col>
            </div>
          </b-row>
        </FormulateForm>
        <FormulateForm
          v-if="serviceParameter === 'DistanceAndTime'"
          key="distance-and-time-form"
          ref="kilometerForm"
          v-model="kilometerForm"
        >
          <b-row class="border my-2 py-3" style="border-radius: 0.5rem; margin: 2px">
            <span>
              {{ $t('maintenance.hourmeter.textInfo.kilometerForm') }}
            </span>

            <b-col md="6">
              <div class="my-2">
                <FormulateInput
                  v-model="kilometerForm.intervalDistance"
                  validation-behavior="submit"
                  error-behavior="submit"
                  :validation="
                    serviceParameter !== 'Hourmeter'
                      ? [['required'], ['greaterThanZero'], ['min', kilometerForm.reminderDistance]]
                      : [['min', kilometerForm.reminderDistance]]
                  "
                  :validation-messages="{
                    greaterThanZero: $t('global.validation.minPositiveOnly'),
                    min: $t('maintenance.validation.reminderDistance'),
                  }"
                  name="intervalDistance"
                  :validation-rules="{ greaterThanZero }"
                  type="number"
                  prefix
                  suffix
                  :help="'required'"
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>{{ $t('maintenance.form.intKm') }} </label>
                      <a v-b-tooltip.topleft :title="`${$t('maintenance.tooltip.intDistance')}`">
                        <i class="icon-outline_info" />
                      </a>
                    </div>
                  </template>
                  <template #prefix>
                    <div class="formulate-input-prefix">
                      <span>{{ $t('maintenance.form.every') }}</span>
                    </div>
                  </template>
                  <template #suffix>
                    <div class="formulate-input-suffix">
                      <span>{{ $t('dashboard.object.km') }}</span>
                    </div>
                  </template>
                </FormulateInput>
              </div>
            </b-col>
            <b-col md="6">
              <div class="my-2">
                <FormulateInput
                  v-model="kilometerForm.reminderDistance"
                  validation-behavior="submit"
                  error-behavior="submit"
                  :validation="
                    serviceParameter === 'DistanceAndTime'
                      ? [['required'], ['greaterThanZero'], ['max', kilometerForm.intervalDistance]]
                      : ['max', kilometerForm.intervalDistance]
                  "
                  :validation-messages="{
                    greaterThanZero: $t('global.validation.minPositiveOnly'),
                    max: $t('maintenance.validation.reminderDistance'),
                  }"
                  name="reminderDistance"
                  :validation-rules="{ greaterThanZero }"
                  type="number"
                  prefix
                  suffix
                  :help="'required'"
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>
                        {{ $t('maintenance.form.remindKm') }}
                      </label>
                      <span v-b-tooltip.topleft :title="`${$t('maintenance.tooltip.kmReminder')}`">
                        <i class="icon-outline_info" />
                      </span>
                    </div>
                  </template>
                  <template #prefix>
                    <div class="formulate-input-prefix">
                      <span>{{ $t('maintenance.form.every') }}</span>
                    </div>
                  </template>
                  <template #suffix>
                    <div class="formulate-input-suffix">
                      <span>{{ $t('dashboard.object.km') }}</span>
                    </div>
                  </template>
                </FormulateInput>
              </div>
            </b-col>
            <b-col md="6">
              <div class="my-3">
                <FormulateInput
                  v-model="kilometerForm.intervalTime"
                  validation-behavior="submit"
                  error-behavior="submit"
                  :validation="
                    serviceParameter === 'DistanceAndTime'
                      ? [['required'], ['greaterThanZero'], ['maxInterval', kilometerForm]]
                      : ['maxInterval', kilometerForm]
                  "
                  :validation-messages="{
                    greaterThanZero: $t('global.validation.minPositiveOnly'),
                    maxInterval: $t('maintenance.validation.reminderTime'),
                  }"
                  name="intervalTime"
                  :validation-rules="{ greaterThanZero }"
                  type="number"
                  prefix
                  suffix
                  :help="'required'"
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>{{ $t('maintenance.form.intTime') }} </label>
                      <span v-b-tooltip.topleft :title="`${$t('maintenance.tooltip.intTime')}`">
                        <i class="icon-outline_info" />
                      </span>
                    </div>
                  </template>
                  <template #prefix>
                    <div class="formulate-input-prefix">
                      <span>{{ $t('maintenance.form.every') }}</span>
                    </div>
                  </template>
                  <template #suffix>
                    <div class="multiselect w-25 period-select">
                      <multiselect
                        v-model="kilometerForm.intPeriodeSelect"
                        :placeholder="`${$t('global.form.select')} ${$t('global.object.period')}`"
                        :options="intPeriodeOptions"
                        :class="{ 'is-invalid': $v.kilometerForm.intPeriodeSelect.$error }"
                        label="text"
                      />
                      <div
                        v-if="$v.kilometerForm.intPeriodeSelect.$error"
                        class="invalid-feedback d-block period-select__error"
                      >
                        {{ $t('maintenance.validation.periodRequired') }}
                      </div>
                    </div>
                  </template>
                </FormulateInput>
              </div>
            </b-col>
            <b-col md="6">
              <div class="my-3">
                <FormulateInput
                  v-model="kilometerForm.reminderTime"
                  validation-behavior="submit"
                  error-behavior="submit"
                  :validation="
                    serviceParameter === 'DistanceAndTime'
                      ? [['required'], ['greaterThanZero'], ['maxInterval', kilometerForm]]
                      : ['maxInterval', kilometerForm]
                  "
                  :validation-messages="{
                    greaterThanZero: $t('global.validation.minPositiveOnly'),
                    maxInterval: $t('maintenance.validation.reminderTime'),
                  }"
                  name="reminderTime"
                  :validation-rules="{ greaterThanZero }"
                  type="number"
                  prefix
                  suffix
                  :help="'required'"
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>{{ $t('maintenance.form.remindTime') }} </label>
                      <span v-b-tooltip.topleft :title="`${$t('maintenance.tooltip.remindTime')}`">
                        <i class="icon-outline_info" />
                      </span>
                    </div>
                  </template>
                  <template #prefix>
                    <div class="formulate-input-prefix">
                      <span>{{ $t('maintenance.form.before') }}</span>
                    </div>
                  </template>
                  <template #suffix>
                    <div class="multiselect w-25 period-select">
                      <multiselect
                        v-model="kilometerForm.reminderPeriodeSelect"
                        :placeholder="`${$t('global.form.select')} ${$t('global.object.period')}`"
                        :options="reminderPeriodeOptions"
                        :class="{ 'is-invalid': $v.kilometerForm.reminderPeriodeSelect.$error }"
                        label="text"
                      />
                      <div
                        v-if="$v.kilometerForm.reminderPeriodeSelect.$error"
                        class="invalid-feedback d-block period-select__error"
                      >
                        {{ $t('maintenance.validation.periodRequired') }}
                      </div>
                    </div>
                  </template>
                </FormulateInput>
              </div>
            </b-col>
            <b-col v-if="showManual" md="12">
              <div class="form-check-left form-switch">
                <input
                  id="moreinfo-history"
                  v-model="showHideDetail"
                  class="form-check-input me-2"
                  type="checkbox"
                  @click="showHideDetail = !showHideDetail"
                />
                <span class="" for="moreinfo-history">
                  {{ $t('maintenance.form.setNextService') }}
                </span>
              </div>
            </b-col>
            <b-col v-if="showHideDetail" md="6">
              <div class="mt-3">
                <FormulateInput
                  validation-behavior="submit"
                  error-behavior="submit"
                  validation="required"
                  name="startServiceAtDistance"
                  prefix
                  suffix
                  :help="'required'"
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>{{ $t('maintenance.form.odoNextService') }} </label>
                      <span v-b-tooltip.topleft :title="`${$t('report.text.reportPeriodMaximum')}`">
                        <i class="icon-outline_info" />
                      </span>
                    </div>
                  </template>
                  <template #prefix>
                    <div class="formulate-input-prefix">
                      <span>{{ $t('maintenance.form.every') }}</span>
                    </div>
                  </template>
                  <template #suffix>
                    <div class="formulate-input-suffix">
                      <span>{{ $t('dashboard.object.km') }}</span>
                    </div>
                  </template>
                </FormulateInput>
              </div>
            </b-col>
            <b-col v-if="kilometerForm?.intervalDistance && kilometerForm?.intervalTime" md="12">
              <b-alert show variant="primary" class="mc-alert mt-3">
                <i class="mc-fa icon-fill_info" />
                <span class="mc-alert__text">
                  <strong>
                    {{ $t('maintenance.notif.allVehicle') }}
                  </strong>
                  {{
                    methodScheduler == 'Floating'
                      ? $t('maintenance.notif.floatingDistance')
                      : $t('maintenance.notif.fixedDistance')
                  }}
                  <strong>
                    {{ `${thousandFormat(kilometerForm?.intervalDistance)} Km ` }}
                  </strong>
                  {{ $t('maintenance.notif.interval') }}
                  <strong>
                    {{ kilometerForm.intervalTime }} {{ kilometerForm.intPeriodeSelect?.text }}
                  </strong>
                  {{
                    methodScheduler == 'Floating'
                      ? $t('maintenance.notif.floatingFrom')
                      : $t('maintenance.notif.fixedFrom')
                  }}
                </span>
              </b-alert>
            </b-col>
          </b-row>
        </FormulateForm>

        <!-- hourmeter -->
        <FormulateForm
          v-if="serviceParameter === 'Hourmeter'"
          key="hourmeter-form"
          ref="hourmeterForm"
          v-model="hourmeterForm"
        >
          <b-row class="border my-2 py-3" style="border-radius: 0.5rem; margin: 2px">
            <span> {{ $t('maintenance.hourmeter.textInfo.hourmeterForm') }} </span>

            <b-col md="6">
              <div class="my-2">
                <FormulateInput
                  v-model="hourmeterForm.intervalHourmeter"
                  type="number"
                  validation-behavior="submit"
                  error-behavior="submit"
                  :validation="
                    serviceParameter === 'Hourmeter'
                      ? [['required'], ['greaterThanZero'], ['min', +hourmeterForm.reminderHourmeter]]
                      : [['min', +hourmeterForm.reminderHourmeter]]
                  "
                  :validation-messages="{
                    greaterThanZero: $t('global.validation.minPositiveOnly'),
                    min: $t('maintenance.validation.reminderHourmeter'),
                  }"
                  name="intervalHourmeter"
                  :validation-rules="{ greaterThanZero }"
                  prefix
                  suffix
                  :help="'required'"
                  @input="getConflict"
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>{{ $t('maintenance.hourmeter.interval') }} </label>
                      <a v-b-tooltip.topleft :title="`${$t('maintenance.tooltip.intHourmeter')}`">
                        <i class="icon-outline_info" />
                      </a>
                    </div>
                  </template>
                  <template #prefix>
                    <div class="formulate-input-prefix">
                      <span>{{ $t('maintenance.form.every') }}</span>
                    </div>
                  </template>
                  <template #suffix>
                    <div class="formulate-input-suffix">
                      <span>{{ $t('global.time.hours') }}</span>
                    </div>
                  </template>
                </FormulateInput>
              </div>
            </b-col>

            <b-col md="6">
              <div class="my-2">
                <FormulateInput
                  v-model="hourmeterForm.reminderHourmeter"
                  type="number"
                  validation-behavior="submit"
                  error-behavior="submit"
                  :validation="
                    serviceParameter === 'Hourmeter'
                      ? [
                          ['required', serviceParameter === 'Hourmeter'], ['greaterThanZero'],
                          ['max', +hourmeterForm.intervalHourmeter],
                        ]
                      : ['max', +hourmeterForm.intervalHourmeter]
                  "
                  :validation-messages="{
                    greaterThanZero: $t('global.validation.minPositiveOnly'),
                    max: $t('maintenance.validation.reminderHourmeter'),
                  }"
                  name="reminderHourmeter"
                  :validation-rules="{ greaterThanZero }"
                  prefix
                  suffix
                  :help="'required'"
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>
                        {{ $t('maintenance.hourmeter.reminder') }}
                        <i class="text-danger">*</i>
                      </label>
                      <span
                        v-b-tooltip.topleft
                        :title="`${$t('maintenance.tooltip.hourmeterReminder')}`"
                      >
                        <i class="icon-outline_info"></i>
                      </span>
                    </div>
                  </template>
                  <template #prefix>
                    <div class="formulate-input-prefix">
                      <span>{{ $t('maintenance.form.before') }}</span>
                    </div>
                  </template>
                  <template #suffix>
                    <div class="formulate-input-suffix">
                      <span>{{ $t('global.time.hours') }}</span>
                    </div>
                  </template>
                </FormulateInput>
              </div>
            </b-col>

            <b-col v-if="hourmeterForm?.intervalHourmeter" md="12">
              <b-alert show variant="primary" class="mc-alert mt-3">
                <i class="mc-fa icon-fill_info" />
                <span class="mc-alert__text">
                  <strong>
                    {{ $t('maintenance.notif.allVehicle') }}
                  </strong>
                  {{ $t('maintenance.notif.hourtime') }}
                  <strong>
                    {{ `${thousandFormat(hourmeterForm?.intervalHourmeter)} Jam ` }}
                  </strong>
                  {{
                    methodScheduler == 'Floating'
                      ? $t('maintenance.notif.floatingFrom')
                      : $t('maintenance.notif.fixedFrom')
                  }}
                </span>
              </b-alert>
            </b-col>
          </b-row>
        </FormulateForm>

        <!-- refrigerator -->
        <FormulateForm
          v-if="serviceParameter === 'Refrigerator'"
          key="refrigerator-form"
          ref="refrigeratorForm"
          v-model="refrigeratorForm"
        >
          <b-row class="border my-2 py-3" style="border-radius: 0.5rem; margin: 2px">
            <span> {{ $t('maintenance.refrigerator.textInfo.refrigeratorForm') }} </span>

            <b-col md="6">
              <div class="my-2">
                <FormulateInput
                  v-model="refrigeratorForm.intervalRefrigerator"
                  type="number"
                  validation-behavior="submit"
                  error-behavior="submit"
                  :validation="[
                    ['required'], ['greaterThanZero'],
                    ['min', +refrigeratorForm.reminderRefrigerator],
                  ]"
                  :validation-messages="{
                    greaterThanZero: $t('global.validation.minPositiveOnly'),
                    min: $t('maintenance.validation.reminderRefrigerator'),
                  }"
                  name="intervalRefrigerator"
                  :validation-rules="{ greaterThanZero }"
                  prefix
                  suffix
                  :help="'required'"
                  @input="getConflict"
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>{{ $t('maintenance.refrigerator.interval') }} </label>
                      <a
                        v-b-tooltip.topleft
                        :title="`${$t('maintenance.tooltip.intRefrigerator')}`"
                      >
                        <i class="icon-outline_info" />
                      </a>
                    </div>
                  </template>
                  <template #prefix>
                    <div class="formulate-input-prefix">
                      <span>{{ $t('maintenance.form.every') }}</span>
                    </div>
                  </template>
                  <template #suffix>
                    <div class="formulate-input-suffix">
                      <span>{{ $t('global.time.hours') }}</span>
                    </div>
                  </template>
                </FormulateInput>
              </div>
            </b-col>

            <b-col md="6">
              <div class="my-2">
                <FormulateInput
                  v-model="refrigeratorForm.reminderRefrigerator"
                  type="number"
                  validation-behavior="submit"
                  error-behavior="submit"
                  :validation="[
                    ['required'], ['greaterThanZero'],
                    ['max', +refrigeratorForm.intervalRefrigerator],
                  ]"
                  :validation-messages="{
                    greaterThanZero: $t('global.validation.minPositiveOnly'),
                    max: $t('maintenance.validation.reminderRefrigerator'),
                  }"
                  name="reminderRefrigerator"
                  :validation-rules="{ greaterThanZero }"
                  prefix
                  suffix
                  :help="'required'"
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>
                        {{ $t('maintenance.refrigerator.reminder') }}
                        <i class="text-danger">*</i>
                      </label>
                      <span
                        v-b-tooltip.topleft
                        :title="`${$t('maintenance.tooltip.refrigeratorReminder')}`"
                      >
                        <i class="icon-outline_info"></i>
                      </span>
                    </div>
                  </template>
                  <template #prefix>
                    <div class="formulate-input-prefix">
                      <span>{{ $t('maintenance.form.before') }}</span>
                    </div>
                  </template>
                  <template #suffix>
                    <div class="formulate-input-suffix">
                      <span>{{ $t('global.time.hours') }}</span>
                    </div>
                  </template>
                </FormulateInput>
              </div>
            </b-col>

            <b-col v-if="refrigeratorForm?.intervalRefrigerator" md="12">
              <b-alert show variant="primary" class="mc-alert mt-3">
                <i class="mc-fa icon-fill_info" />
                <span class="mc-alert__text">
                  <strong>{{ $t('maintenance.notif.allVehicle') }}</strong>
                  {{ $t('maintenance.notif.refrigeratorTime') }}
                  <strong>
                    {{ `${thousandFormat(refrigeratorForm?.intervalRefrigerator)} Jam ` }}
                  </strong>
                  {{
                    methodScheduler == 'Floating'
                      ? $t('maintenance.notif.floatingFrom')
                      : $t('maintenance.notif.fixedFrom')
                  }}
                </span>
              </b-alert>
            </b-col>
          </b-row>
        </FormulateForm>
      </b-card>
    </b-skeleton-wrapper>

    <template v-if="showConflict && ssgroup.ssgroup.vehicles.length">
      <div class="mc-table--5 mc-table--rowspan card p-4">
        <McGrapqlTable
          :fields="fields"
          :apiClient="query"
          :searchable="false"
          :hasSelectAll="true"
          :showPagination="false"
          :withCard="false"
          trackBy="vehicleId"
          :hasBorder="true"
          :cardPadding="false"
        >
          <template #title>
            <h4 class="card-title mt-2">
              {{ $t('maintenance.conflict.conflictScheduler') }}
            </h4>
          </template>
          <template #tab-button>
            <div class="pt-0 px-3">
              <b-alert show variant="warning" class="mc-alert d-flex justify-content-start">
                <i class="mc-fa icon-fill_alert-triangle" />
                <span class="mc-alert__text">
                  <span class="text-capitalize">
                    <strong>
                      {{ totalConflict }}
                      {{ $t('maintenance.conflict.text.fleet') }}
                      {{ $t('maintenance.conflict.conflict') }}.
                    </strong>
                  </span>
                  {{ $t('maintenance.conflict.desc') }}
                </span>
              </b-alert>
            </div>
          </template>
          <template #cell(oldInterval)="data">
            {{ $t('maintenance.form.every') }}
            <span v-if="!data.item.service2Ssgroup">
              <span v-if="data.item.type === 'Hourmeter'" class="text-danger">
                {{ minuteToHour(data.item.intervalHourmeter) }}
              </span>
              <span v-if="data.item.type === 'Refrigerator'" class="text-danger">
                {{ minuteToHour(data.item.intervalRefrigerator) }}
              </span>
              <span v-if="data.item.type === 'DistanceAndTime'">
                <span class="text-danger"> {{ `${data.item.intervalDistance} Km & ` }}</span>
                <span class="text-danger">
                  {{ data.item.intervalTime }}
                  {{ convertPeriodName(data.item.intervalPeriod) }}
                </span>
              </span>
            </span>
            <span v-else>
              <span v-if="data.item.service2Ssgroup.type === 'Hourmeter'" class="text-danger">
                {{ minuteToHour(data.item.service2Ssgroup.intervalHourmeter) }}
              </span>
              <span
                v-if="data.item.service2Ssgroup.type === 'Refrigerator'"
                class="text-danger"
              >
                {{ minuteToHour(data.item.service2Ssgroup.intervalRefrigerator) }}
              </span>
              <span v-if="data.item.service2Ssgroup.type === 'DistanceAndTime'">
                <span class="text-danger">
                  {{ `${data.item.service2Ssgroup.intervalDistance} Km & ` }}
                </span>
                <span class="text-danger">
                  {{ data.item.service2Ssgroup.intervalTime }}
                  {{ convertPeriodName(data.item.service2Ssgroup.intervalPeriod) }}
                </span>
              </span>
            </span>
          </template>
          <template #cell(method)="data">
            {{ `${data.item.method} -> ${methodScheduler}` }}
          </template>
          <template #cell(newInterval)>
            <span v-if="serviceParameter === 'DistanceAndTime'" class="mc-table--rowspan-rows">
              <p v-if="!kilometerForm.intervalDistance && !kilometerForm.intervalTime">-</p>

              <p v-else>
                {{ $t('maintenance.form.every') }}
                <span class="text-success">{{ `${kilometerForm.intervalDistance} Km & ` }}</span>
                <span class="text-success">
                  {{ kilometerForm.intervalTime }} {{ kilometerForm.intPeriodeSelect?.text }}
                </span>
              </p>
            </span>

            <span v-if="serviceParameter === 'Hourmeter'" class="mc-table--rowspan-rows">
              <p v-if="!hourmeterForm.intervalHourmeter">-</p>

              <p v-else>
                {{ $t('maintenance.form.every') }}

                <span class="text-success">
                  {{ hourmeterForm.intervalHourmeter }}
                  {{ $t('global.time.hours') }}
                </span>
              </p>
            </span>

            <span v-if="serviceParameter === 'Refrigerator'" class="mc-table--rowspan-rows">
              <p v-if="!refrigeratorForm.intervalRefrigerator">-</p>

              <p v-else>
                {{ $t('maintenance.form.every') }}
                <span class="text-success">
                  {{ refrigeratorForm.intervalRefrigerator }}
                  {{ $t('global.time.hours') }}
                </span>
              </p>
            </span>
          </template>
          <template #cell(nextService)="data">
            <span v-if="serviceParameter == 'DistanceAndTime'">
              {{
                `${calculateStartServiceAt(
                  Number(kilometerForm.intervalDistance),
                  Number(data.item.vehicle.odometer) ?? 0,
                  methodScheduler,
                  null
                )}
                Km & 
                ${momentDateShortMonth(
                  calculateStartServiceAt(
                    kilometerForm.intervalTime,
                    new Date(),
                    methodScheduler,
                    !kilometerForm.intPeriodeSelect ? 'day' : kilometerForm.intPeriodeSelect.value
                  )
                )}`
              }}
            </span>
            <span v-else-if="serviceParameter === 'Hourmeter'">
              {{
                minuteToHour(
                  calculateStartServiceAt(
                    Number(hourmeterForm.intervalHourmeter) * 60,
                    data.item.vehicle.hourmeter == null ? 0 : Number(data.item.vehicle.hourmeter),
                    methodScheduler,
                    null
                  )
                )
              }}
            </span>
            <span v-else-if="serviceParameter === 'Refrigerator'">
              {{
                minuteToHour(
                  calculateStartServiceAt(
                    Number(refrigeratorForm.intervalRefrigerator) * 60,
                    0,
                    methodScheduler,
                    null
                  )
                )
              }}
            </span>
          </template>
        </McGrapqlTable>
      </div>
    </template>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Multiselect from 'vue-multiselect'
import McGrapqlTable from '@/components/McGrapqlTable'
import McButton from '@/components/McButton'
import {
  GET_SERVICE_SCHEDULES,
  GET_SERVICE_SCHEDULE_GROUP_BY_ID,
} from '@/services/api/maintenance/serviceSchedules'
import { required } from 'vuelidate/lib/validators'
import { SERVICES } from '@/services/api/setting/maintenance/setting/services'
import { Helper } from '@/mixin/helper'
import McRadioButton from '@/components/McRadioButton'
import {
  CREATE_SERVICE_2_SSGROUP,
  UPDATE_SERVICE_2_SSGROUP,
} from '@/services/api/maintenance/ssgroup'
import { mapGetters } from 'vuex'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Servis',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    McGrapqlTable,
    McRadioButton,
    McButton,
  },
  mixins: [Helper],

  apollo: {
    ssgroup: {
      query: GET_SERVICE_SCHEDULE_GROUP_BY_ID,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            ssgroupId: Number(this.$route.params.ssgroupId),
          },
        }
      },
      result({ data, loading }) {
        if (loading || !data.ssgroup.isSuccessful) {
          return
        }
        if (data.ssgroup.isSuccessful) {
          this.services = data.ssgroup.ssgroup.service2Ssgroup

          if (this.filterId.length == 0) {
            this.filterId = this.services.map((item) => {
              return item.serviceId
            })
          }

          const selected = this.services.find((item) => {
            return item.serviceId == this.$route.params.serviceId
          })

          this.kilometerForm = {
            intPeriodeSelect: this.checkValue('d'),
            reminderPeriodeSelect: this.checkValue('d')
          }

          if (!selected) return

          this.servicesDatas = selected.service

          this.serviceForm = {
            categoryService: selected.service.serviceCategory.name,
            serviceAction: selected.service.serviceAction.action,
            compServiceSelect: selected.service.name,
          }

          this.methodScheduler = selected.method
          this.serviceParameter = selected.type

          this.hourmeterForm = {
            intervalHourmeter: Math.floor(selected.intervalHourmeter / 60),
            reminderHourmeter: Math.floor(selected.reminderHourmeter / 60),
          }

          this.refrigeratorForm = {
            intervalRefrigerator: Math.floor(selected.intervalRefrigerator / 60),
            reminderRefrigerator: Math.floor(selected.reminderRefrigerator / 60),
          }

          this.kilometerForm = {
            intPeriodeSelect: this.checkValue(selected.intervalPeriod),
            reminderPeriodeSelect: this.checkValue(selected.reminderPeriod),
            intervalDistance: selected.intervalDistance,
            reminderDistance: selected.reminderDistance,
            reminderTime: selected.reminderTime,
            intervalTime: selected.intervalTime,
            startServiceAtDistance: selected.startServiceAtDistance,
            startServiceAtTime: selected.startServiceAtTime,
          }

          this.oldData =
            this.serviceParameter === 'Hourmeter'
              ? {
                  method: this.methodScheduler,
                  type: this.serviceParameter,
                  ...this.serviceForm,
                  ...this.hourmeterForm,
                }
              : this.serviceParameter === 'Refrigerator'
              ? {
                  method: this.methodScheduler,
                  type: this.serviceParameter,
                  ...this.serviceForm,
                  ...this.refrigeratorForm,
                }
              : {
                  method: this.methodScheduler,
                  type: this.serviceParameter,
                  ...this.serviceForm,
                  ...this.kilometerForm,
                }
        }
      },
    },
    services: {
      query: SERVICES,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (loading) return
        this.componentServices = data.services.services.data
      },
    },
  },
  validations: {
    serviceForm: {
      compServiceSelect: { required },
    },
    kilometerForm: {
      intPeriodeSelect: { required },
      reminderPeriodeSelect: { required },
    },
  },

  data() {
    return {
      ssgroup: {
        ssgroup: { vehicles: [] },
      },
      ssgroupId: '',
      conflict: [],
      deletedConflict: [],
      licensePlateSelect: [],
      serviceForm: {
        categoryService: null,
        compServiceSelect: null,
        serviceAction: null,
        // startServiceAtDistance: null,
        // startServiceAtTime: null,
      },
      kilometerForm: {
        intPeriodeSelect: null,
        reminderPeriodeSelect: null,
        intervalDistance: null,
        reminderDistance: null,
        intervalTime: null,
        reminderTime: null,
      },
      hourmeterForm: {
        intervalHourmeter: null,
        reminderHourmeter: null,
      },
      refrigeratorForm: {
        intervalRefrigerator: null,
        reminderRefrigerator: null,
      },
      licensePlateOptions: ['L 1234 LL', 'W 1234 WW', 'P 1234 PP'],
      services: [],
      selected: '',
      showHideDetail: false,
      showNotifInfo: false,
      rendered: true,
      isAdd: false,
      isEdit: false,
      servicesDatas: [],
      showManual: false,
      filterId: [],
      showConflict: false,
      totalConflict: 0,
      serviceConflict: null,
      oldData: {},
      componentServices: [],
      methodScheduler: 'Floating',
      serviceParameter: 'DistanceAndTime',
    }
  },

  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    isMGMAndMO() {
      const data = this.getFeatureFlagValue('customFeature.mgm')
      return (
        Array.isArray(data?.company_id) &&
        data.company_id.includes(this.getCompanyId()) &&
        data.features?.maintenance_order
      )
    },
    title() {
      return this.isAdd
        ? this.$t('maintenance.menu.titleAdd.schedule')
        : this.$t('maintenance.detailSchedule.title')
    },

    items() {
      return [
        {
          text: this.$t('maintenance.title'),
          to: { name: 'Service' },
        },
        {
          text: this.$t('maintenance.frontPage.title.serviceGroup'),
          to: { name: 'Service Group' },
        },
        {
          text: this.$t('maintenance.detailGroup.title'),
          to: { name: 'Detail Group Service' },
        },
        {
          text: this.isAdd
            ? this.$t('maintenance.menu.titleAdd.schedule')
            : this.$t('maintenance.detailSchedule.title'),
        },
      ]
    },

    fields() {
      return [
        {
          key: 'vehicle.licensePlate',
          label: this.$t('global.object.licensePlate'),
          sortable: false,
        },
        {
          key: 'service',
          label: this.$t('maintenance.form.compService'),
          sortable: false,
          formatter: (val) => {
            return `${val.name} (${val.serviceAction.action})`
          },
        },
        {
          key: 'vehicle.odometer',
          label: this.$t('maintenance.order.kilometerFleet'),
          sortable: false,
          formatter: (val) => {
            return `${this.thousandFormat(val)} Km`
          },
        },
        {
          key: 'vehicle.hourmeter',
          label: this.$t('maintenance.form.hourmeterFleet'),
          sortable: false,
          formatter: (val) => {
            return this.minuteToHour(val)
          },
        },
        {
          key: 'ssgroup.name',
          label: this.$t('maintenance.field.previousGroup'),
          sortable: false,
          formatter: (val) => {
            if (val) {
              return val
            }

            return '-'
          },
        },
        {
          key: 'method',
          label: this.$t('maintenance.field.method'),
          sortable: false,
        },
        {
          key: 'oldInterval',
          label: this.$t('maintenance.field.oldInterval'),
          sortable: false,
        },
        {
          key: 'newInterval',
          label: this.$t('maintenance.field.newInterval'),
          sortable: false,
          thClass: 'mc-table--170',
        },
        {
          key: 'nextService',
          label: this.$t('maintenance.field.nextService'),
          sortable: false,
        },
      ]
    },

    intPeriodeOptions() {
      return [
        { text: this.$t('global.time.day'), value: 'day', time: 1 },
        { text: this.$t('global.time.week'), value: 'week', time: 7 },
        { text: this.$t('global.time.month'), value: 'month', time: 30 },
      ]
    },

    reminderPeriodeOptions() {
      return [
        { text: this.$t('global.time.day'), value: 'day', time: 1 },
        { text: this.$t('global.time.week'), value: 'week', time: 7 },
        { text: this.$t('global.time.month'), value: 'month', time: 30 },
      ]
    },

    parameterServiceOptions() {
      return [
        { key: 'DistanceAndTime', label: this.$t('maintenance.form.kmTime') },
        { key: 'Hourmeter', label: this.$t('maintenance.form.hourmeter') },
        this.isMGMAndMO && { key: 'Refrigerator', label: this.$t('maintenance.form.refrigerator') },
      ].filter(Boolean)
    },

    methodSchedulerOptions() {
      return [
        {
          key: 'Floating',
          label: this.$t('maintenance.floating'),
          description: this.$t('maintenance.form.floatingDesc'),
          tooltip: this.$t('maintenance.tooltip.floating'),
        },
        {
          key: 'Fixed',
          label: this.$t('maintenance.fixed'),
          description: this.$t('maintenance.form.fixedDesc'),
          tooltip: this.$t('maintenance.tooltip.fixed'),
        },
      ]
    },

    queryCompService() {
      return {
        get: async (opts) => {
          let result = {}

          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            orderBy: opts.sorts,
            search: opts.search,
          }

          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: SERVICES,
            variables: {
              filter: {
                ...filter,
                excludeServiceId: this.filterId ? this.filterId : null,
              },
            },
          })

          const data = res.data.services.services

          result = {
            metadata: {
              total_count: data.pagination.total,
              page: data.pagination.page,
            },
            data: {
              paginated_result: data.data,
            },
          }

          return result
        },
      }
    },

    fieldCompService() {
      return [
        {
          key: 'name',
          label: this.$t('maintenance.field.compName'),
          sortable: true,
          formatter: (val, key, item) => {
            return `${val} (${item.serviceAction.action})`
          },
        },
        {
          key: 'serviceCategory.name',
          label: this.$t('global.field.category'),
          sortable: true,
        },
      ]
    },

    query() {
      return {
        get: async () => {
          return this.getConflict()
        },
        delete: async (id) => {
          return this.deleteConflict(id)
        },
      }
    },
  },

  watch: {
    'serviceForm.compServiceSelect': {
      async handler(value) {
        if (!value && typeof value !== 'number') return
        this.deletedConflict.splice(0, this.deletedConflict.length)
        await this.$nextTick()
        this.showConflict = false

        setTimeout(() => {
          const compService = this.componentServices.find((item) => {
            return item.serviceId == value
          })

          this.servicesDatas = compService
        }, 750)

        this.serviceForm.categoryService = this.servicesDatas?.serviceCategory?.name
        this.serviceForm.serviceAction = this.servicesDatas?.serviceAction?.action
        setTimeout(() => {
          if (value) this.showConflict = true
        }, 100)
      },
      deep: true,
    },
    'serviceForm.intervalDistance': function (val) {
      this.showNotifInfo = val ? true : false
    },
    'serviceForm.intervalHourmeter': function (val) {
      this.showNotifInfo = val ? true : false
    },
  },

  mounted() {
    setTimeout(() => {
      this.ssgroupId = Number(this.$route.params.ssgroupId)
      if (!this.$route.params.serviceId) {
        this.isAdd = true
      } else {
        this.isEdit = true
        this.servicesDatas.serviceId = Number(this.$route.params.serviceId)
      }
    }, 500)
  },

  methods: {
    greaterThanZero({ value }) {
      return Number(value) > 0
    },

    checkValue(data) {
      switch (data) {
        case 'd':
          return { text: this.$t('global.time.day'), value: 'day', time: 1 }
        case 'w':
          return { text: this.$t('global.time.week'), value: 'week', time: 7 }
        case 'm':
          return { text: this.$t('global.time.month'), value: 'month', time: 30 }

        default:
          break
      }
    },
    calculateStartServiceAt(interval, initialValue, method, period) {
      if (!interval) interval = 0
      const isFloating = method === 'Floating'

      if (typeof initialValue === 'number') {
        if (isFloating) return Number(parseFloat(initialValue).toFixed(2)) + Number(interval)

        const division = Number(parseFloat(initialValue).toFixed(2)) / Number(interval)

        return (division % 1 === 0 ? division + 1 : Math.ceil(division)) * Number(interval)
      }

      const start = isFloating ? new Date(initialValue) : new Date(initialValue.getFullYear(), 0, 1)

      if (period === 'month') {
        const getMonth = start.getMonth()
        const int = Number(interval)
        let multiplier = initialValue.getMonth() / interval
        if (multiplier % 1 === 0) multiplier += 1
        else multiplier = Math.ceil(multiplier)
        const floating = isFloating ? Number(1) : Number(multiplier)
        const totalMonth = Number(getMonth) + Number(int) * Number(floating)

        return new Date(start.setMonth(totalMonth))
      }

      if (period === 'year') {
        return new Date(start.setFullYear(Number(start.getFullYear()) + Number(interval)))
      }

      const addOn = Number(interval) * (period === 'day' ? 86400000 : 604800000)

      const diffDate = Math.abs(start.valueOf() - initialValue.valueOf())
      const division = diffDate / Number(addOn)

      return new Date(
        start.valueOf() + Number(addOn) * (division % 1 === 0 ? 1 : Math.ceil(division))
      )
    },
    async getConflict() {
      if (this.deletedConflict.length) {
        const filter = this.conflict.filter((f) => !this.deletedConflict.includes(f.vehicleId))
        const result = {
          data: filter,
          pagination: {
            total: filter.length,
            page: 1,
          },
        }

        this.totalConflict = filter.length
        this.showConflict = this.totalConflict ? true : false
        return result
      }

      const { data } = await this.$apollo.query({
        query: GET_SERVICE_SCHEDULES,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            pagination: {
              show: 999,
              page: 1,
            },
            vehicleId: this.ssgroup.ssgroup.vehicles.map((x) => Number(x.id)),
            serviceId: this.$route.params.serviceId
              ? Number(this.$route.params.serviceId)
              : this.serviceForm.compServiceSelect,
          },
        },
      })

      const result = {
        data: data.serviceSchedules.serviceSchedules.data.serviceSchedules,
        pagination: data.serviceSchedules.serviceSchedules.pagination,
      }
      this.conflict = data.serviceSchedules.serviceSchedules.data.serviceSchedules
      this.totalConflict = data.serviceSchedules.serviceSchedules.pagination.total
      this.showConflict = this.totalConflict ? true : false
      result.data.forEach((el) => {
        el.startServiceAtDistance =
          this.serviceParameter == 'DistanceAndTime'
            ? this.calculateStartServiceAt(
                this.kilometerForm.intervalDistance,
                el.vehicle.odometer == null ? 0 : el.vehicle.odometer,
                this.methodScheduler,
                null
              )
            : null
        el.startServiceAtTime =
          this.serviceParameter == 'DistanceAndTime'
            ? this.calculateStartServiceAt(
                this.kilometerForm.intervalTime,
                new Date(),
                this.methodScheduler,
                !this.kilometerForm.intPeriodeSelect
                  ? 'day'
                  : this.kilometerForm.intPeriodeSelect.value
              )
            : null
        el.startServiceAtHourmeter =
          this.serviceParameter == 'Hourmeter'
            ? this.calculateStartServiceAt(
                this.hourmeterForm.intervalHourmeter * 60,
                el.vehicle.hourmeter == null ? 0 : el.vehicle.hourmeter,
                this.methodScheduler,
                null
              )
            : null
      })
      return result
    },

    deleteConflict(id) {
      this.deletedConflict.push(Number(id))
      return this.deletedConflict
    },

    async handleSubmit() {
      const parameterForm =
        this.serviceParameter === 'Hourmeter'
          ? this.$refs.hourmeterForm
          : this.serviceParameter === 'Refrigerator'
          ? this.$refs.refrigeratorForm
          : this.$refs.kilometerForm
      const forms = [this.$refs.serviceForm, parameterForm].filter(Boolean)

      forms.forEach((form) => form.showErrors())
      if (this.serviceParameter === 'DistanceAndTime') this.$v.kilometerForm.$touch()

      const hasInvalidPeriod =
        this.serviceParameter === 'DistanceAndTime' && this.$v.kilometerForm.$invalid
      if (forms.some((form) => form.hasErrors) || hasInvalidPeriod) return false

      const nullData = {
        intervalDistance: null,
        reminderDistance: null,
        intervalTime: null,
        intervalPeriod: null,
        reminderTime: null,
        reminderPeriod: null,
        intervalHourmeter: null,
        reminderHourmeter: null,
        intervalRefrigerator: null,
        reminderRefrigerator: null,
      }

      if (this.isAdd) {
        let data = {}
        if (this.serviceParameter === 'Hourmeter') {
          data = {
            ...nullData,
            intervalHourmeter: Number(this.hourmeterForm.intervalHourmeter),
            reminderHourmeter: Number(this.hourmeterForm.reminderHourmeter),
          }
        } else if (this.serviceParameter === 'Refrigerator') {
          data = {
            ...nullData,
            intervalRefrigerator: Number(this.refrigeratorForm.intervalRefrigerator),
            reminderRefrigerator: Number(this.refrigeratorForm.reminderRefrigerator),
          }
        } else {
          data = {
            ...nullData,
            intervalDistance: Number(this.kilometerForm.intervalDistance),
            reminderDistance: Number(this.kilometerForm.reminderDistance),
            intervalTime: Number(this.kilometerForm.intervalTime),
            intervalPeriod: this.kilometerForm.intPeriodeSelect.value,
            reminderTime: Number(this.kilometerForm.reminderTime),
            reminderPeriod: this.kilometerForm.reminderPeriodeSelect.value,
          }
        }

        const serviceInput = {
          type: this.serviceParameter,
          method: this.methodScheduler,
          ssgroupId: Number(this.$route.params.ssgroupId),
          serviceId: this.servicesDatas.serviceId,
          ...data,
        }

        const res = await this.$apollo.mutate({
          mutation: CREATE_SERVICE_2_SSGROUP,
          variables: {
            input: serviceInput,
          },
        })

        if (res.data.createService2Ssgroup.isSuccessful) {
          this.$mcToast.success(this.$t('global.alert.text.added'))
          this.toDetailPage()
        } else this.$mcToast.error(this.$t('global.alert.text.failedSaved'))
      } else if (this.isEdit) {
        let oldData = {}
        if (this.oldData.type === 'Hourmeter') {
          oldData = {
            ...nullData,
            intervalHourmeter: Number(this.oldData.intervalHourmeter),
            reminderHourmeter: Number(this.oldData.reminderHourmeter),
          }
        } else if (this.oldData.type === 'Refrigerator') {
          oldData = {
            ...nullData,
            intervalRefrigerator: Number(this.oldData.intervalRefrigerator),
            reminderRefrigerator: Number(this.oldData.reminderRefrigerator),
          }
        } else {
          oldData = {
            ...nullData,
            intervalDistance: Number(this.oldData.intervalDistance),
            reminderDistance: Number(this.oldData.reminderDistance),
            intervalTime: Number(this.oldData.intervalTime),
            intervalPeriod: this.oldData.intPeriodeSelect.value,
            reminderTime: Number(this.oldData.reminderTime),
            reminderPeriod: this.oldData.reminderPeriodeSelect.value,
          }
        }

        let newData = {}
        if (this.serviceParameter === 'Hourmeter') {
          newData = {
            ...nullData,
            intervalHourmeter: Number(this.hourmeterForm.intervalHourmeter),
            reminderHourmeter: Number(this.hourmeterForm.reminderHourmeter),
          }
        } else if (this.serviceParameter === 'Refrigerator') {
          newData = {
            ...nullData,
            intervalRefrigerator: Number(this.refrigeratorForm.intervalRefrigerator),
            reminderRefrigerator: Number(this.refrigeratorForm.reminderRefrigerator),
          }
        } else {
          newData = {
            ...nullData,
            intervalDistance: Number(this.kilometerForm.intervalDistance),
            reminderDistance: Number(this.kilometerForm.reminderDistance),
            intervalTime: Number(this.kilometerForm.intervalTime),
            intervalPeriod: this.kilometerForm.intPeriodeSelect.value,
            reminderTime: Number(this.kilometerForm.reminderTime),
            reminderPeriod: this.kilometerForm.reminderPeriodeSelect.value,
          }
        }

        const res = await this.$apollo.mutate({
          mutation: UPDATE_SERVICE_2_SSGROUP,
          variables: {
            input: {
              newData: {
                ...newData,
                type: this.serviceParameter,
                method: this.methodScheduler,
              },
              oldData: {
                ...oldData,
                type: this.oldData.type,
                method: this.oldData.method,
              },
              serviceId: Number(this.$route.params.serviceId),
              ssgroupId: Number(this.$route.params.ssgroupId),
              type: this.oldData.type,
            },
          },
        })

        const updateResponse = res.data.updateService2Ssgroup

        if (updateResponse.isSuccessful) {
          this.$mcToast.success(this.$t('global.alert.text.changed'))
          this.toDetailPage()
        } else if (updateResponse.errorName === 'ResourceBeingUsed') {
          this.$mcToast.error(
            this.$t('maintenance.errorMessages.ServiceScheduleGroupBeingUsed')
          )
        } else this.$mcToast.error(this.$t('global.alert.text.failedSaved'))
      }
    },

    clearForm() {
      if (this.isEdit) {
        this.serviceParameter = this.oldData.type
        this.methodScheduler = this.oldData.method

        if (this.serviceParameter == 'DistanceAndTime') {
          this.kilometerForm = {
            intervalDistance: Number(this.oldData.intervalDistance),
            reminderDistance: Number(this.oldData.reminderDistance),
            intervalTime: Number(this.oldData.intervalTime),
            intPeriodeSelect: this.oldData.intPeriodeSelect,
            reminderTime: Number(this.oldData.reminderTime),
            reminderPeriodeSelect: this.oldData.reminderPeriodeSelect,
            // startServiceAtDistance: null,
            // startServiceAtTime: null,
          }
        } else if (this.serviceParameter === 'Hourmeter') {
          this.hourmeterForm = {
            intervalHourmeter: Number(this.oldData.intervalHourmeter),
            reminderHourmeter: Number(this.oldData.reminderHourmeter),
          }
        } else if (this.serviceParameter === 'Refrigerator') {
          this.refrigeratorForm = {
            intervalRefrigerator: Number(this.oldData.intervalRefrigerator),
            reminderRefrigerator: Number(this.oldData.reminderRefrigerator),
          }
        }
      } else {
        this.serviceForm = {
          type: 'DistanceAndTime',
          method: 'Floating',
          categoryService: null,
          compServiceSelect: null,
          serviceAction: null,
        }

        this.kilometerForm = {
          intPeriodeSelect: null,
          reminderPeriodeSelect: null,
          intervalDistance: null,
          reminderDistance: null,
          intervalTime: null,
          reminderTime: null,
          // startServiceAtDistance: null,
          // startServiceAtTime: null,
        }

        this.hourmeterForm = {
          intervalHourmeter: null,
          reminderHourmeter: null,
        }

        this.refrigeratorForm = {
          intervalRefrigerator: null,
          reminderRefrigerator: null,
        }
      }
    },

    handleBack() {
      this.clearForm()
      this.toDetailPage()
    },

    toDetailPage() {
      this.$router.push({
        name: 'Detail Group Service',
        params: { ssgroupId: this.$route.params.ssgroupId },
      })
    },

    setMethod(value) {
      this.methodScheduler = value
    },

    setParameter(value) {
      this.serviceParameter = value
      if (!this.isEdit) {
        if (value === 'DistanceAndTime') {
          this.hourmeterForm = {
            reminderHourmeter: null,
            intervalHourmeter: null,
          }
          this.refrigeratorForm = {
            reminderRefrigerator: null,
            intervalRefrigerator: null,
          }
        } else {
          this.kilometerForm = {
            intPeriodeSelect: null,
            reminderPeriodeSelect: null,
            intervalDistance: null,
            reminderDistance: null,
            intervalTime: null,
            reminderTime: null,
            // startServiceAtDistance: null,
            // startServiceAtTime: null,
          }

          if (value === 'Hourmeter') {
            this.refrigeratorForm = {
              reminderRefrigerator: null,
              intervalRefrigerator: null,
            }
          } else {
            this.hourmeterForm = {
              reminderHourmeter: null,
              intervalHourmeter: null,
            }
          }
        }
      } else {
        if (value === 'DistanceAndTime') {
          this.kilometerForm = {
            intervalDistance: Number(this.oldData.intervalDistance),
            reminderDistance: Number(this.oldData.reminderDistance),
            intervalTime: Number(this.oldData.intervalTime),
            intPeriodeSelect: this.oldData.intPeriodeSelect.value,
            reminderTime: Number(this.oldData.reminderTime),
            reminderPeriodeSelect: this.oldData.reminderPeriodeSelect.value,
          }
        } else if (value === 'Hourmeter') {
          this.hourmeterForm = {
            intervalHourmeter: Number(this.hourmeterForm.intervalHourmeter),
            reminderHourmeter: Number(this.hourmeterForm.reminderHourmeter),
          }
        } else if (value === 'Refrigerator') {
          this.refrigeratorForm = {
            intervalRefrigerator: Number(this.refrigeratorForm.intervalRefrigerator),
            reminderRefrigerator: Number(this.refrigeratorForm.reminderRefrigerator),
          }
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.period-select {
  position: relative;

  &__error {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 0.25rem;
  }
}

.formulate-input-label {
  :required {
    .formulate-input-label:after {
      content: ' *';
      color: red;
    }
  }
}
</style>
